var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title'),_c('payment-methods-form',{ref:"form"}),_c('payment-methods',{attrs:{"on-add-payment-method":_vm.addUserPaymentMethod}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }